export const MobileLoanActionsDrawerTestIds = {
  DRAWER: 'mobile-loan-actions-drawer.container',
  CLOSE_BUTTON: 'mobile-loan-actions-drawer.close-button',
};
